import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserInfoModel } from 'src/app/conta/models/user-info.model';
import { LocalCookiesService } from 'src/app/conta/services/local-cookie.service';

@Component({
  selector: 'app-menu-login',
  templateUrl: './menu-login.component.html',
  styles: [
  ]
})
export class MenuLoginComponent implements OnInit {
  conta: UserInfoModel;
  constructor(private localCookieService: LocalCookiesService,
    private router: Router) { }

  ngOnInit(): void {
  }
  usuarioLogado(): boolean {
    //TODO: implementar logica de sessão
    let token = this.localCookieService.obterAccessToken();
    let logado = token != null;
    if (logado)
      this.conta = this.localCookieService.obterUserInfo();
    return logado;
  }
  logout() {
    let semAcesso = this.localCookieService.removerDados();
    if (semAcesso)
    {
     
      this.router.navigate(['/conta/login']);
     // window.location.reload();
    }
  }
}
